import React from "react";

type VideoProps = React.DetailedHTMLProps<
  React.VideoHTMLAttributes<HTMLVideoElement>,
  HTMLVideoElement
> & {
  videoUrl: string;
  mimeType: string;
};

export const Video: React.FC<VideoProps> = ({
  videoUrl,
  mimeType,
  ...props
}) => {
  return (
    <video controls {...props}>
      <source src={videoUrl} type={mimeType} />
      Your browser does not support HTML video.
    </video>
  );
};
